import type { ApiClient } from './ApiClient';

// Forme alignée sur GET /dashboard/attendance-weekly-summary (ATT-04,
// apps/api/src/lib/attendanceWeeklySummary.ts) — seule source de vérité pour
// cette route. Bornée à Lundi-Vendredi (voir ce fichier serveur pour le
// détail de cette décision). `rate`/`weeklyRate` : fraction 0-1 ou `null`
// (aucune donnée), jamais un pourcentage déjà multiplié — même convention que
// `recoveryRate` (financialDashboard.ts).
export type AttendanceWeeklySummaryDayOfWeek = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY';

export interface AttendanceWeeklySummaryDay {
  dayOfWeek: AttendanceWeeklySummaryDayOfWeek;
  presentCount: number;
  totalCount: number;
  rate: number | null;
}

export interface AttendanceWeeklySummary {
  isEmpty: boolean;
  weeklyRate: number | null;
  presentCount: number;
  totalCount: number;
  days: AttendanceWeeklySummaryDay[];
}

export interface AttendanceWeeklySummaryResponse {
  summary: AttendanceWeeklySummary;
}

export function getAttendanceWeeklySummary(client: ApiClient, accessToken: string): Promise<AttendanceWeeklySummaryResponse> {
  return client.get<AttendanceWeeklySummaryResponse>('/dashboard/attendance-weekly-summary', { accessToken });
}
